export const GET_SUMMARY_REPORT_REQUEST = 'GET_SUMMARY_REPORT_REQUEST';
export const GET_SUMMARY_REPORT_SUCCESS = 'GET_SUMMARY_REPORT_SUCCESS';
export const GET_SUMMARY_REPORT_FAIL = 'GET_SUMMARY_REPORT_FAIL';
export const GET_DRIVER_REPORT_REQUEST = 'GET_DRIVER_REPORT_REQUEST';
export const GET_DRIVER_REPORT_SUCCESS = 'GET_DRIVER_REPORT_SUCCESS';
export const GET_DRIVER_REPORT_FAIL = 'GET_DRIVER_REPORT_FAIL';
export const GET_DETAILS_REPORT_REQUEST = 'GET_DETAILS_REPORT_REQUEST';
export const GET_DETAILS_REPORT_SUCCESS = 'GET_DETAILS_REPORT_SUCCESS';
export const GET_DETAILS_REPORT_FAIL = 'GET_DETAILS_REPORT_FAIL';
export const DOWNLOAD_REPORT_REQUEST = 'DOWNLOAD_REPORT_REQUEST';
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS';
export const DOWNLOAD_REPORT_FAIL = 'DOWNLOAD_REPORT_FAIL';
export const RESET = 'REPORT/RESET';
